module.exports = __webpack_public_path__ + "img/logo.fdc5e29b.svg";